import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document
	.querySelectorAll('.js-benefits-slider')
	.forEach(container => {
		new Swiper(container.querySelector('.swiper'), {
			spaceBetween: 8,
            slidesPerView: 'auto',
            navigation: {
				nextEl: container.querySelector('.swiper-next'),
				prevEl: container.querySelector('.swiper-prev')
			},
            breakpoints: {
				600: {
					slidesPerView: 'auto',
					spaceBetween: 11,
                    grid: {
                        rows: 1
                    }
				},
				1100: {
					slidesPerView: 3,
					spaceBetween: 11,
                    grid: {
                        rows: 2
                    }
				},
				1601: {
                    slidesPerView: 3,
					spaceBetween: 11,
                    grid: {
                        rows: 2
                    }
				}
            }
		});
	});
